import { render, staticRenderFns } from "./SubTable.vue?vue&type=template&id=2a4bebc0&"
import script from "./SubTable.vue?vue&type=script&lang=js&"
export * from "./SubTable.vue?vue&type=script&lang=js&"
import style0 from "./SubTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports